let FreeNodeCheckPointDirection = {
    Unknown :0,
    Left :1,
    Top :2,
    Rigth :3,
    Bottom :4
}
export default FreeNodeCheckPointDirection